var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 1080,
    fill: "#2B2A29"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M348.1 489.31H251.16V532.016H348.1V566.076H251.16V619H217.1V455.25H348.1V489.31ZM613.022 548.383H566.072V520.366H613.022V473.16H641.039V520.366H687.861V548.383H641.039V594.949H613.022V548.383ZM862.807 455.25V619H828.747V566.076L814.337 619H780.277L765.867 566.076V619H731.807V455.25H769.797L797.307 556.382L824.817 455.25H862.807Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFm);
export default __webpack_public_path__ + "static/media/F+M.aca2ee562a0457ab3b3c29cb0224b04f.svg";
export { ForwardRef as ReactComponent };